import StringAPI from 'api/StringAPI';
import { ServerRequestStatusType } from 'store/actions/serverRequestStatusType';
var ServerRequestModel = /** @class */ (function () {
    function ServerRequestModel(type, id, metadata, status) {
        if (status === void 0) { status = ServerRequestStatusType.Sent; }
        this.type = type;
        this.id = id;
        this.metadata = metadata;
        this.status = status;
    }
    /**
     * Get unique key for request
     */
    ServerRequestModel.prototype.getKey = function () {
        return StringAPI.createServerRequestId(this.type, this.id);
    };
    return ServerRequestModel;
}());
export { ServerRequestModel };



//////////////////
// WEBPACK FOOTER
// ./src/models/server/serverRequestModel.ts
// module id = 320
// module chunks = 50